module.exports = __webpack_public_path__ + "media/yetiDeath.cf0eb557.mp3";